import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "../helpers/JsonMappedModel";
import User from "../user/User";
import { toBase64 } from "../../mcn-helpers";
import Image from "../image/Image";
import SalePage from "../salePage/SalePage";
import Store from "../domain/Store";
import Addons from "../Addons/Addons";
import BlockCollection from "../blocks/BlockCollection";
import Tracking from "../tracking/Tracking";
var _attributes = /*#__PURE__*/new WeakMap();
export default class PreSellPage extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [PreSellPage.id_attribute_name]: null,
      [PreSellPage.user_id_attribute_name]: null,
      [PreSellPage.last_updated_user_attribute_name]: User,
      [PreSellPage.owner_attribute_name]: User,
      [PreSellPage.sale_page_attribute_name]: SalePage,
      [PreSellPage.sale_page_id_attribute_name]: null,
      [PreSellPage.domain_id_attribute_name]: null,
      [PreSellPage.domain_attribute_name]: Store,
      [PreSellPage.status_attribute_name]: null,
      [PreSellPage.blocks_attribute_name]: BlockCollection,
      [PreSellPage.title_attribute_name]: null,
      [PreSellPage.url_title_attribute_name]: null,
      [PreSellPage.featured_image_attribute_name]: Image,
      [PreSellPage.pixels_attribute_name]: Tracking,
      [PreSellPage.addons_attribute_name]: Addons,
      [PreSellPage.visit_logs_count_attribute_name]: 0,
      [PreSellPage.clicks_count_attribute_name]: 0
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getTitleAttributeName() {
    return this.title_attribute_name;
  }
  static getUrlTitleAttributeName() {
    return this.url_title_attribute_name;
  }
  static getFeaturedImageAttributeName() {
    return PreSellPage.featured_image_attribute_name;
  }
  static getStatusAttributeName() {
    return PreSellPage.status_attribute_name;
  }
  static getDomainIdAttributeName() {
    return PreSellPage.domain_id_attribute_name;
  }
  static getSalePageIdAttributeName() {
    return PreSellPage.sale_page_id_attribute_name;
  }
  static getAddonsAttributeName() {
    return PreSellPage.addons_attribute_name;
  }
  static getPixelsAttributeName() {
    return PreSellPage.pixels_attribute_name;
  }
  static getBlocksAttributeName() {
    return PreSellPage.blocks_attribute_name;
  }
  getId() {
    return this.getAttribute(PreSellPage.id_attribute_name);
  }
  getDomainId() {
    return this.getAttribute(PreSellPage.domain_id_attribute_name);
  }
  getPageId() {
    return this.getAttribute(PreSellPage.id_attribute_name);
  }
  getPageTitle() {
    return this.getAttribute(PreSellPage.title_attribute_name);
  }
  getTitle() {
    return this.getAttribute(PreSellPage.title_attribute_name);
  }
  getPageFeaturedImage() {
    return this.getAttribute(PreSellPage.featured_image_attribute_name);
  }
  getPageFeaturedImageUrl() {
    var _this$getPageFeatured;
    return (_this$getPageFeatured = this.getPageFeaturedImage()) === null || _this$getPageFeatured === void 0 ? void 0 : _this$getPageFeatured.getImageUrl();
  }
  getPageUrlTitle() {
    return this.getAttribute(PreSellPage.url_title_attribute_name);
  }
  getDomain() {
    return this.getAttribute(PreSellPage.domain_attribute_name);
  }
  getSalePage() {
    return this.getAttribute(PreSellPage.sale_page_attribute_name);
  }
  hasDomainDnsActive() {
    let salePage = this.getSalePage();
    return salePage instanceof SalePage ? salePage.hasDomainDnsActive() : false;
  }
  hasDomainSslActive() {
    let salePage = this.getSalePage();
    return salePage instanceof SalePage ? salePage.hasDomainSslActive() : false;
  }
  getCountry() {
    var _this$getSalePage;
    return (_this$getSalePage = this.getSalePage()) === null || _this$getSalePage === void 0 ? void 0 : _this$getSalePage.getOfferCountry();
  }
  getCountryName(lang) {
    var _this$getCountry;
    return (_this$getCountry = this.getCountry()) === null || _this$getCountry === void 0 ? void 0 : _this$getCountry.getCountryTranslation(lang);
  }
  getOwner() {
    return this.getAttribute(PreSellPage.owner_attribute_name);
  }
  getLastUpdatedUser() {
    return this.getAttribute(PreSellPage.last_updated_user_attribute_name);
  }
  getLastUpdatedUserName() {
    var _this$getLastUpdatedU, _this$getLastUpdatedU2;
    return (_this$getLastUpdatedU = this.getLastUpdatedUser()) === null || _this$getLastUpdatedU === void 0 || (_this$getLastUpdatedU2 = _this$getLastUpdatedU.getUserName) === null || _this$getLastUpdatedU2 === void 0 ? void 0 : _this$getLastUpdatedU2.call(_this$getLastUpdatedU);
  }
  getLastUpdatedUserRoleName() {
    var _this$getLastUpdatedU3, _this$getLastUpdatedU4, _this$getLastUpdatedU5;
    return (_this$getLastUpdatedU3 = this.getLastUpdatedUser()) === null || _this$getLastUpdatedU3 === void 0 || (_this$getLastUpdatedU4 = _this$getLastUpdatedU3.getUserRole) === null || _this$getLastUpdatedU4 === void 0 || (_this$getLastUpdatedU4 = _this$getLastUpdatedU4.call(_this$getLastUpdatedU3)) === null || _this$getLastUpdatedU4 === void 0 || (_this$getLastUpdatedU5 = _this$getLastUpdatedU4.getRoleName) === null || _this$getLastUpdatedU5 === void 0 ? void 0 : _this$getLastUpdatedU5.call(_this$getLastUpdatedU4);
  }
  getOwnerName() {
    var _this$getOwner, _this$getOwner$getUse;
    return (_this$getOwner = this.getOwner()) === null || _this$getOwner === void 0 || (_this$getOwner$getUse = _this$getOwner.getUserName) === null || _this$getOwner$getUse === void 0 ? void 0 : _this$getOwner$getUse.call(_this$getOwner);
  }
  getOwnerRoleName() {
    var _this$getOwner2, _this$getOwner2$getUs, _this$getOwner2$getUs2;
    return (_this$getOwner2 = this.getOwner()) === null || _this$getOwner2 === void 0 || (_this$getOwner2$getUs = _this$getOwner2.getUserRole) === null || _this$getOwner2$getUs === void 0 || (_this$getOwner2$getUs = _this$getOwner2$getUs.call(_this$getOwner2)) === null || _this$getOwner2$getUs === void 0 || (_this$getOwner2$getUs2 = _this$getOwner2$getUs.getRoleName) === null || _this$getOwner2$getUs2 === void 0 ? void 0 : _this$getOwner2$getUs2.call(_this$getOwner2$getUs);
  }
  getVisitsCount() {
    return this.getAttribute(PreSellPage.visit_logs_count_attribute_name);
  }
  getClicksCount() {
    return this.getAttribute(PreSellPage.clicks_count_attribute_name);
  }
  getPreSellPageUrl() {
    let domain = this.getDomain();
    let domain_name = process.env.VUE_APP_PAGE_DEFUALT_DOMAIN;
    if (domain instanceof Store) {
      let protocol = domain.isSSL() ? 'https://' : 'http://';
      domain_name = [protocol, domain.getDomainName()].join('');
    }
    return [domain_name, 'blogs', this.getPageUrlTitle(), toBase64(this.getPageId())].join('/');
  }
  getUrl() {
    let domain = this.getDomain();
    let domain_name = process.env.VUE_APP_PAGE_DEFUALT_DOMAIN;
    if (domain instanceof Store) {
      let protocol = domain.isSSL() ? 'https://' : 'http://';
      domain_name = [protocol, domain.getDomainName()].join('');
    }
    return [domain_name, 'blogs', this.getPageUrlTitle(), toBase64(this.getPageId())].join('/');
  }
  getLink() {
    return this.getUrl();
  }
  getPreSellPageSelectObject(text = 'text', value = 'value') {
    return {
      [text]: this.getTitle(),
      [value]: this.getId()
    };
  }
}
_defineProperty(PreSellPage, "ACTIVE_STATUS", 'active');
_defineProperty(PreSellPage, "INACTIVE_STATUS", 'inactive');
_defineProperty(PreSellPage, "id_attribute_name", 'id');
_defineProperty(PreSellPage, "user_id_attribute_name", 'user_id');
_defineProperty(PreSellPage, "last_updated_user_attribute_name", 'last_updated_user');
_defineProperty(PreSellPage, "owner_attribute_name", 'owner');
_defineProperty(PreSellPage, "sale_page_attribute_name", 'sale_page');
_defineProperty(PreSellPage, "sale_page_id_attribute_name", 'sale_page_id');
_defineProperty(PreSellPage, "domain_id_attribute_name", 'domain_id');
_defineProperty(PreSellPage, "domain_attribute_name", 'domain');
_defineProperty(PreSellPage, "status_attribute_name", 'status');
_defineProperty(PreSellPage, "blocks_attribute_name", 'blocks');
_defineProperty(PreSellPage, "title_attribute_name", 'title');
_defineProperty(PreSellPage, "url_title_attribute_name", 'url_title');
_defineProperty(PreSellPage, "featured_image_attribute_name", 'featured_image');
_defineProperty(PreSellPage, "pixels_attribute_name", 'pixels');
_defineProperty(PreSellPage, "addons_attribute_name", 'addons');
_defineProperty(PreSellPage, "visit_logs_count_attribute_name", 'visit_logs_count');
_defineProperty(PreSellPage, "clicks_count_attribute_name", 'clicks_count');